import { AppData, Log } from "@lightningjs/sdk";
import Lightning from "@lightningjs/sdk/src/Lightning"
import { TextBox } from "@lightningjs/ui-components";
import { AppSetup } from "../../lib/app-setup";
import { Helper } from "../../lib/helper";

export interface OnlyUrlTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  page: any
}

export default class OnlyUrl
  extends Lightning.Component<OnlyUrlTemplateSpec>
  implements Lightning.Component<OnlyUrlTemplateSpec>
{
  static override _template(): Lightning.Component.Template<OnlyUrlTemplateSpec> {
    return {
      w: (w) => w,
      h: (h) => h,
      rect: true,
      color: 0x00000000,
      Header: undefined,
      Wrapper: undefined
    }
  }

  override _getFocused() {
    return this.tag('Wrapper');
  }
  set data({url, name}) {
    Log.info('OnlyUrl: data:', url, name)
    const { appConfig } = AppData as AppSetup
    if(appConfig?.enableOnlyURLDisplay){
      this.patch({
        Header: {
          x: (w) => w/2,
          y: 100,
          mountX: 0.5,
          text: { text: name, textColor: 0xffffffff, fontSize: 48, fontFace: Helper.getFontFamily('Black') },
        },
        Wrapper: {
          type: TextBox,
          x: (w)=>w/2,
          y: (h)=>h/2,
          mount: 0.5,
          w: 800,
          h: 100,
          content: url,
          style: {
            textStyle: {
              fontSize: 48,
              padding: 10,
              fontFace: Helper.getFontFamily('Black'),
            }
          }
        }
      })
    } 
  }
}